import set from 'lodash/fp/set';
import findIndex from 'lodash/findIndex';
// checks if the user with 'availableRoles' can visit routes protected with 'availableRoles'
export const matchRoles = (requiredRoles, availableRoles) => {
  const match = requiredRoles.find((role) => {
    return findIndex(availableRoles, (r) => r.name === role) !== -1;
  });

  return match;
};

export const notMatchPermissions = (
  requiredPermissions = [],
  availablePermissions = [],
) => {
  const match = requiredPermissions.some((permission) => {
    return availablePermissions
      .reduce((acc, curr) => curr.name, [])
      .includes(permission);
  });

  return !match;
};

//TODO: notMatchPermissions & matchPermissions are the same, refactor to one function
export const matchPermissions = (
  requiredPermissions = [],
  availablePermissions = [],
) => {
  const match = requiredPermissions.find((permission) => {
    return findIndex(availablePermissions, (r) => r.name === permission) !== -1;
  });
  return match;
};

// filters routes configuration based on the user roles
export const getAvailableRoutes = (routes) => (roles) => (permissions) => {
  return routes.map((route) =>
    set(
      'routes',
      route.routes.filter((r) => {
        if (!r.allowedRoles) {
          return true;
        }

        if (
          matchRoles(r.allowedRoles, roles) &&
          !r.notAllowedPermissions &&
          !r.allowedPermissions
        ) {
          return true;
        }
        if (
          matchRoles(r.allowedRoles, roles) &&
          r.allowedPermissions &&
          matchPermissions(r.allowedPermissions, permissions)
        ) {
          return true;
        }
        return (
          matchRoles(r.allowedRoles, roles) &&
          notMatchPermissions(r.notAllowedPermissions, permissions)
        );
      }),
      route,
    ),
  );
};

// filters route links in the navbar based on the user roles
export const getAvailableRouteLinks = (config) => (roles) => (permissions) => {
  const filterChildren = (children) => {
    if (!children) {
      return null;
    }
    return children.filter((c) => {
      if (
        (!c.allowedRoles || matchRoles(c.allowedRoles, roles)) &&
        (!c.notAllowedPermissions ||
          notMatchPermissions(c.notAllowedPermissions, permissions)) &&
        (!c.allowedPermissions ||
          matchPermissions(c.allowedPermissions, permissions))
      ) {
        return true;
      }
      return false;
    });
  };

  return config.map((c) => {
    return {
      ...c,
      pages: c.pages.reduce((acc, curr) => {
        if (
          (!curr.allowedRoles || matchRoles(curr.allowedRoles, roles)) &&
          (!curr.notAllowedPermissions ||
            notMatchPermissions(curr.notAllowedPermissions, permissions)) &&
          (!curr.allowedPermissions ||
            matchPermissions(curr.allowedPermissions, permissions))
        ) {
          acc.push(set('children', filterChildren(curr.children), curr));
        }
        return acc;
      }, []),
    };
  });
};
